module.exports = __webpack_public_path__ + "img/zhengcedongtai_img.3743e027.png";